import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'lookupContainsDisplayValue'
})
export class LookupContainsDisplayValuePipe implements PipeTransform {

  transform(value: any, find: any[], selectedIndex: number): any {
    if (!value || value.length === null || !find || find.length === null){
      return value;
    }
   
    let resultArray = [];
    for (let item of value) {
      if (find.length > 0) {
        for (let ii of find) {
          if (item.display.match('^.*'+ii+'.*$') || item.id === selectedIndex) {
            resultArray.push(item);
            break;
          }
        }
      } else {
        if (item.display.match('^.*'+find+'.*$') || item.id === selectedIndex) {
            resultArray.push(item);
        }
      }
    }

    return resultArray;
  }

}
